module.exports = {
      id: "comm-finance-usage",
      viewBox: "0 0 245.601 29.882",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-finance",
      toString: function () {
        return this.url;
      }
    }